import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { FileText } from "lucide-react";
import { Badge } from "../../base/badge/badge";
import { getColorSchemeFromString } from "../../base/badge/badge-utils";
import { Item, ItemContent, ItemDescription, ItemMedia, ItemTitle } from "../../base/item/item";
export const ArtifactCard = /*#__PURE__*/ React.forwardRef(({ artifact, variant = "name-only", itemVariant = "default", size = "default", className, titleSlot, descriptionSlot, rightSlot }, ref)=>{
    let secondaryText;
    if (variant === "with-description") {
        secondaryText = artifact.description;
    }
    const showDescription = descriptionSlot ?? secondaryText;
    const showTypeBadge = variant === "with-type" && artifact.type;
    return /*#__PURE__*/ _jsxs(Item, {
        ref: ref,
        variant: itemVariant,
        size: size,
        className: className,
        children: [
            /*#__PURE__*/ _jsx(ItemMedia, {
                variant: "icon",
                children: /*#__PURE__*/ _jsx(FileText, {
                    className: "h-4 w-4"
                })
            }),
            /*#__PURE__*/ _jsxs(ItemContent, {
                children: [
                    /*#__PURE__*/ _jsx(ItemTitle, {
                        children: titleSlot ?? artifact.name
                    }),
                    showDescription && /*#__PURE__*/ _jsx(ItemDescription, {
                        children: showDescription
                    })
                ]
            }),
            rightSlot ? rightSlot : showTypeBadge && /*#__PURE__*/ _jsx(Badge, {
                variant: "outline",
                colorScheme: getColorSchemeFromString(artifact.type ?? ""),
                className: "self-center",
                children: artifact.type
            })
        ]
    });
});
ArtifactCard.displayName = "ArtifactCard";

//# sourceMappingURL=artifact-card.js.map